<script>
import Datatable from '@/components/Datatable'

export default {
  name: 'UserSessionsModal',
  props:[
    "list"
  ],
  components: {
    Datatable,
  },
  data() {
    return {

      columns: [
          { name: 'Ad', key: 'name', width: 150 },
          { name: 'Cihaz', key: 'platform', width: 140 },
          { name: 'IP', key: 'ip', width: 140 },
          { name: 'Oluşturma', key: 'created_at', className: 'text-end', width: 150  },
          { name: 'Son Kullanım', key: 'last_used_at', className: 'text-center', width: 200, orderable: true,  },
          { name: '', key: 'action', orderable: false, width: 120 },
        ],
        tableData: {
          data: [],
          pagination: {},
          detail: false,
          excel: false,
        },
        isLoading: false,
        pageLoading: false,
        params: {
          per_page: 50,
          page: 1
        },
        sortColumn: null,
        sortOrder: null,
        searchQuery: '',
        pagination:'pagination'
    }
  },
  computed: {
    isAdmin() {
      try{
        const userdata = JSON.parse(localStorage.getItem('userdata')) || {};
        return userdata.role_name === 'admin';
      }catch(e){
        return false;
      }
    }
  },
  watch:{
    list(){
      this.rows = []
      this.loadPage();
    }
  },


  methods: {


    async loadPage() {
      if(!this.list || !this.list.username) return;
      this.isLoading = true

      try {
        const response = await  this.$http.post(`users/${this.list.username}/sessions`, { params: this.params, sort_column:this.sortColumn, sort_crder:this.sortOrder, search_query: this.searchQuery });

        // backend returns successResponse wrapper
        if(response.data && response.data.content){
          this.tableData.data = response.data.content;
        } else if(response.data.data){
          this.tableData.data = response.data.data;
        } else {
          this.tableData.data = [];
        }

        this.isLoading = false

      } catch (error) {
        // eslint-disable-next-line no-console
        this.isLoading = false
      }

    },

    pageChange(page){
      if (this.isLoading) return;

      this.params.page = page;
      this.loadPage();
    },

   async revoke(row){
      if(!confirm('Bu oturumu sonlandırmak istediğinize emin misiniz?')) return;
      try{
        await this.$http.delete(`users/sessions/${row.id}`);
        this.loadPage();
      }catch(err){
        alert('Oturum sonlandırılamadı');
      }
    },

    handleSortColumn(columnKey, sortOrder) {
      if (this.isLoading) return;

      this.params.page = 1;


      this.sortColumn = columnKey;
      this.sortOrder = sortOrder;
      this.loadPage();
    },

    close(){
      this.$parent.$bvModal.hide('modal-sessions')
    }
  },
};
</script>

<template>
  <b-modal id="modal-sessions" size="lg" :title="`${list.username} Açık Oturumlar`"  no-close-on-backdrop hide-footer>
    <div class="row" id="modalScroll">
      <div class="col-12">
        <Datatable
            :columns="columns"
            :tableData="tableData"
            @sort-column="handleSortColumn"
            @page-change="pageChange"
            :loading="isLoading"
            :poading="pageLoading"
            :tableDataLoad="pagination">

          <template #abilities="{ row }">
            <span v-if="row.abilities && row.abilities.length">{{ Array.isArray(row.abilities) ? row.abilities.join(', ') : row.abilities }}</span>
            <span v-else> - </span>
          </template>

          <template #platform="{ row }">
            <span v-if="row.platform">{{ row.platform }}</span>
            <span v-else> - </span>
          </template>

          <template #ip="{ row }">
            <span v-if="row.ip">{{ row.ip }}</span>
            <span v-else> - </span>
          </template>

          <template #created_at="{ row }">
            <span>{{ row.created_at || '-' }}</span>
          </template>

          <template #last_used_at="{ row }">
            <span>{{ row.last_used_at || '-' }}</span>
          </template>

          <template #action="{ row }">
            <button v-if="isAdmin" class="btn btn-sm btn-danger" @click.prevent="revoke(row)"> Sonlandır</button>
            <button v-else class="btn btn-sm btn-secondary" disabled>Yetki Yok</button>
          </template>
        </Datatable>
      </div>
    </div>
</b-modal>
</template>
